module.exports = __webpack_public_path__ + "static/media/ShutdownIcon.9282b209.png";